<div class="hb-container hb-container--width-lg">
  <div class="hb-grid hb-mb--xl">
    <div class="hb-cell hb-cell--12of12 hb-cell--3of12@md">
      <stat-filter (selectedFilters)="filterVisning($event)" seksjon="studentbolig"></stat-filter>
    </div>
    <div class="hb-cell hb-cell--12of12 hb-cell--9of12@md">
      <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Lån til studentbolig</h1>
      <hb-accordion class="hb-mb--lg">
        <hb-accordion-element id="studentboligID">
          <h2 title class="hb-accordion-tittel">Om lån til studentbolig</h2>
          <div body="">
            <p>
              Lån til studentboliger skal bidra til å gi studenter ved høyrere utdanningsinstitusjoner og fagskoler i Norge et rimelig og forutsigbart boligtilbud, som et
              supplement til det private boligmarkedet.
            </p>
            <p>Husbanken kan som hovedregel bare gi lånet til prosjekter som allerede har fått innvilget tilskudd til studentboliger.</p>
            <p>Ordningen var gjeldene fra 2020.</p>
            <p><strong>Søknad:</strong> Det sendes inn en søknad om lån basert på de retningslinjer som til enhver tid gjelder.</p>
            <p><strong>Tilsagn:</strong> Husbanken gir en lovnad om finansiering med hjelp av lån. Gjennom statsbudsjettet gis Husbanken en årlig tilsagnsramme for lån.</p>
            <p><strong>Utbetaling:</strong> Når prosjektet er ferdigstilt og klart til å bli tatt i bruk, blir lånet utbetalt når det er godkjent av Husbanken.</p>
            <p>
              Husbanken har de seneste årene gjort mye arbeid knyttet til datainnsamling og statistikk, og bakover i tid kan det være noen avvik fra tidligere rapporterte tall fra
              Husbanken på grunn av endringer i måten dataene hentes på. Blant annet har rapportering knyttet til tilvisningsavtaler før 2017 blitt gjort ved manuelle tellinger.
            </p>
            <h3>Slik teller Husbanken tilsagn innenfor et år:</h3>
            <p>Et tilsagn kan justeres på i løpet av inneværende år eller i de påfølgende år etter at tilsagnet er gitt.</p>
            <h3>Vi behandler endringer i tilsagn på følgende måte:</h3>
            <p>
              Dersom antall boliger justeres opp i samme år som tilsagnet blir gitt første gang, telles antall nye boliger med i inneværende år. Dersom antall boliger i tilsagnet
              justeres senere år, telles kun endringen i antall boliger i året justeringen på tilsagnet gjøres.
            </p>
            <ul class="hb-list hb-list--gap-none hb-text--sm">
              <li>100 boliger i år 1, + 50 boliger i år 2</li>
              <li>100 boliger telles år 1, 50 boliger telles år 2</li>
            </ul>
            <p>
              Samme logikk benyttes for justeringer i tilsagnsbeløp. Dersom antall boliger eller tilsagnsum justeres ned: Saker med tilsagn kan korrigeres innad i ett år (bli
              annullert, få høyere/lavere tilsagnsbeløp osv.), noe som kan føre til at det kan være forekomster av negative beløp på månedsnivå. Saker som blir annullert året etter
              det året de fikk tilsagn vil ikke fjernes fra det året de belastet tilsagnsrammen. Dataene som er registrert for inneværende år vil dermed kunne endre seg i løpet av
              året, men forblir uendret i statistikken etter 31.12.
            </p>
          </div>
        </hb-accordion-element>
      </hb-accordion>

      <fieldset class="hb-felt">
        <legend class="hb-screenreader-only">Sorter etter</legend>
        <div class="hb-buttongroup">
          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandSoknad" type="radio" (click)="filterTilstand('Søknad')" />
          <label class="hb-button hb-button--standard" for="typeTilstandSoknad">Søknad</label>

          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandTilsagn" type="radio" checked="" (click)="filterTilstand('Tilsagn')" />
          <label class="hb-button hb-button--standard" for="typeTilstandTilsagn">Tilsagn</label>

          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandUtbetaling" type="radio" (click)="filterTilstand('Utbetaling')" />
          <label class="hb-button hb-button--standard" for="typeTilstandUtbetaling">Utbetaling</label>
        </div>
      </fieldset>

      <div class="hb-grid">
        <stat-kpitabell [kpiIder]="kpiListe" [valgtFilter]="valgtFilter" [statistikkType]="statistikkType" class="hb-cell hb-cell--6of12@md"></stat-kpitabell>
      </div>

      <div class="hb-grid">
        <div class="hb-fieldset hb-cell hb-cell--12of12">
          <div class="hb-legend">
            <div class="hb-legend-tekst" aria-hidden="true" id="hva-du-vil-se">Velg hva du vil se:</div>
            <hb-hjelpetekst labelledby="hva-du-vil-se">
              @for (item of objectKeys(typeTekst[statistikkType]); track item) {
                <div>
                  <p class="hb-avstand--ingen">
                    <strong>{{ typeTekst[statistikkType][item][0] }}:</strong>
                  </p>
                  <p class="hb-avstand--avsnitt">{{ typeTekst[statistikkType][item][1] }}</p>
                </div>
              }
            </hb-hjelpetekst>
          </div>
          <fieldset class="hb-felt">
            <legend class="hb-screenreader-only">Velg hva du vil se:</legend>
            <ul class="hb-feltliste hb-feltliste--horisontal">
              @for (value of objectKeys(typeTekst[statistikkType]); track value) {
                <li>
                  <input (change)="selectedRadio($event)" class="hb-radiobutton" [id]="value" type="radio" name="radio1" [value]="value" [checked]="value === graferValgt" />
                  <div class="hb-label">
                    <label class="hb-label-tekst" [for]="value">
                      <span>{{ typeTekst[statistikkType][value][0] }}</span>
                    </label>
                  </div>
                </li>
              }
            </ul>
          </fieldset>
          <stat-kommunefilter></stat-kommunefilter>
        </div>
      </div>

      @if (graferValgt === "soknader") {
        <div class="hb-grid">
          @for (soknadId of grafIderForSoknad; track soknadId) {
            <stat-qlik-graf
              id="{{ soknadId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "boliger") {
        <div class="hb-grid">
          @for (boligId of grafIderForBolig; track boligId) {
            <stat-qlik-graf
              id="{{ boligId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "belop") {
        <div class="hb-grid">
          @for (belopId of grafIderForBelop; track belopId) {
            <stat-qlik-graf
              id="{{ belopId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "kostnad") {
        <div class="hb-grid">
          @for (kostnadId of grafIderForKostnad; track kostnadId) {
            <stat-qlik-graf
              id="{{ kostnadId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@MD"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }
    </div>
  </div>
</div>
